module.exports = __webpack_public_path__ + "media/images/front/sp/dummy/banner_special02-c968d9f9403bec97c61bfbe70d4aea3b.png";